import { render, staticRenderFns } from "./ClientSecretSave.vue?vue&type=template&id=0ef66a7e&scoped=true&"
import script from "./ClientSecretSave.vue?vue&type=script&lang=ts&"
export * from "./ClientSecretSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef66a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef66a7e')) {
      api.createRecord('0ef66a7e', component.options)
    } else {
      api.reload('0ef66a7e', component.options)
    }
    module.hot.accept("./ClientSecretSave.vue?vue&type=template&id=0ef66a7e&scoped=true&", function () {
      api.rerender('0ef66a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientConfiguration/clientSecret/ClientSecretSave.vue"
export default component.exports